import React from "react";

export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <div
      className={["animate-pulse bg-slate-200", className].filter(Boolean).join(" ")}
    />
  );
}
